import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../../helpers/utility';

const initialState = {
  breakReasons: {
    0: {
      break_reason: 'Break',
      allowed_time: '00:00:00',
    },
  },
  error: null,
  loading: false,
};

const breakReasonStart = (state, action) => {
  return updateObject(state, {loading: true});
};

const breakReasonSuccess = (state, action) => {
  return updateObject(state, {
    breakReasons: action.breakReasons,
    loading: false,
  });
};

const breakReasonFail = (state, action) => {
  return updateObject(state, {error: action.error, loading: false});
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.BREAK_REASON_START:
      return breakReasonStart(state, action);
    case actionTypes.BREAK_REASON_SUCCESS:
      return breakReasonSuccess(state, action);
    case actionTypes.BREAK_REASON_FAIL:
      return breakReasonFail(state, action);
    default:
      return state;
  }
};

export default reducer;
